<script setup lang="ts">
interface UiHeaderProps {
    variant?: 'default' | 'sticky'
    size: 'md' | 'lg'
    noContainer?: boolean
}

const props = withDefaults(defineProps<UiHeaderProps>(), {
    variant: 'default',
    size: 'md',
    noContainer: false,
})

</script>

<template>
    <div class="
        w-full
        bg-white 
        flex items-center
        border-b-1 border-solid border-se-gray-300" :class="[
            props.size === 'md' && 'h-16',
            props.size === 'lg' && 'h-23',
            props.variant === 'sticky' && 'sticky top-0 z-50',
        ]" v-safe-area:top>
        <div class="flex flex-1 items-center" :class="[
            props.noContainer ? 'px-4 md:px-8' : 'container mx-auto',
        ]">
            <div class="
            flex items-center
            gap-10
            flex-1
            ">
                <slot name="main" />
            </div>
            <div id="header-actions">
                <slot name="actions" />
            </div>
        </div>
    </div>
</template>